export interface HdKeyBadge {
  name: string;
  abbr: string;
  class: string;
  index?: number;
  tooltipDisabled?: boolean;
}

export function HdKeyBadgesFactory(rawData: any, showPrimaryIndex?: boolean) {
  const badges: HdKeyBadge[] = [];

  if (!rawData) {
    return badges;
  }

  if (rawData.pk_pos !== null && typeof rawData.pk_pos !== 'undefined') {
    badges.push({
      name: 'Primary Key',
      abbr: 'pk',
      class: 'badge-key--pk',
      index: rawData.pk_pos
    });
  }

  if (rawData.partition_key_pos !== null && typeof rawData.partition_key_pos !== 'undefined') {
    badges.push({
      name: 'Partition Key',
      abbr: 'prk',
      class: 'badge-key--partition-key',
      index: rawData.partition_key_pos
    });
  }

  if (rawData.sk_pos !== null && typeof rawData.sk_pos !== 'undefined') {
    if (showPrimaryIndex) {
      badges.push({
        name: 'Primary Index',
        abbr: 'pi',
        class: 'badge-key--sk',
        index: rawData.sk_pos
      });
    } else {
      badges.push({
        name: 'Sort Key',
        abbr: 'sk',
        class: 'badge-key--sk',
        index: rawData.sk_pos
      });
    }
  }

  if (rawData.is_dk) {
    badges.push({
      name: 'Dist Key',
      abbr: 'dk',
      class: 'badge-key--dk'
    });
  }

  if (rawData.is_ck) {
    badges.push({
      name: 'Cluster Key',
      abbr: 'ck',
      class: 'badge-key--ck'
    });
  }

  if (!rawData.optional) {
    badges.push({
      name: 'Not Null',
      abbr: 'Not Null',
      class: 'badge-key--not-null',
      tooltipDisabled: true
    });
  }

  return badges;
}
